// PR 53 · fork R — F3 (Z-5) the journal sources J14 / J15 test, listed on the J14 card; F6 (Z-3) a long document read in
// parts. EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_P53R = {
  en: {
    p53r: {
      sourcesTitle: "Journal sources found (J14 / J15 skip system and sub-ledger sources only):",
      blankSource: "(blank)",
      tested: "Tested",
      notTested: "Not tested",
      changed: "changed for this engagement",
      makeTested: "Test",
      makeNotTested: "Do not test",
      truncated: "Only the first 300 source values are listed.",
      rerunNote: "A change applies when the tests are run again.",
      pagesReadParts: "Pages read: {ranges} of {total} ({n} parts)",
    },
  },
  ar: {
    p53r: {
      sourcesTitle: "مصادر القيود الموجودة (يستثني J14 / J15 مصادر النظام والسجلات الفرعية فقط):",
      blankSource: "(فارغ)",
      tested: "مُختبر",
      notTested: "غير مُختبر",
      changed: "تم تغييره لهذا الارتباط",
      makeTested: "اختبار",
      makeNotTested: "عدم الاختبار",
      truncated: "تُعرض أول 300 قيمة مصدر فقط.",
      rerunNote: "يسري التغيير عند تشغيل الاختبارات مرة أخرى.",
      pagesReadParts: "الصفحات المقروءة: {ranges} من {total} ({n} أجزاء)",
    },
  },
};

export default I18N_P53R;
